import {put, select, call} from 'redux-saga/effects';
import {addCardActions} from "../addCard.slice";
import {RootState} from "../../../store/rootReducer";
import {api} from "../../../api/api";
import {cleanImages} from "../../utils/cleanImages";
import {markupFormatter} from "../../../common";

export function* uploadCardSaga() {
    yield put(addCardActions.setUploadInProgress(true));

    const {markup, invertedMarkup, images, addInverted} = yield select((state: RootState) => ({
        markup: state.addCard.markup,
        invertedMarkup: state.addCard.invertedMarkup,
        images: {...state.addCard.images},
        addInverted: state.addCard.addInverted,
    }));
    cleanImages(images, markup);

    yield call(api.addCard, {
        markup,
        images
    });

    if (addInverted === true) {
        yield call(api.addCard, {
            markup: invertedMarkup,
            images,
        })
    }

    const cardTree = markupFormatter.parse(markup);

    yield put(addCardActions.reset(cardTree.icon));
}
